const HOTSPOT = {
    DEFAULT_SCALE: 30
};

export default HOTSPOT;
